module.exports = __webpack_public_path__ + "media/images/cc-4-by-10f2b3436ecd31e52e19ed20fa47ecb4.png";